import { ROOMS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const RoomService = {
  getAll: (params: any) => requests.get(`${ROOMS_URL}`, params),
  create: (params: any) => requests.post(`${ROOMS_URL}`, params,true),
  getSingle: (id: number) => requests.get(`${ROOMS_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.put(`${ROOMS_URL}/${id}`, params, true),
  delete: (id: number) => requests.delete(`${ROOMS_URL}/${id}`),
};